import { basicResetReducer } from '@ackee/redux-utils';
import { combineReducers } from 'redux';

import { authSessionEnd } from '@/modules/auth/services/actions';
import { entitiesReducer as groups } from '@/modules/groups';
import { entitiesReducer as secrets } from '@/modules/secrets';
import { entitiesReducer as securityAudit } from '@/modules/security-audit';
import { entitiesReducer as settings } from '@/modules/settings/services/reducers/entities';
import { entitiesReducer as whitelist } from '@/modules/whitelist';

const entitiesReducer = combineReducers({
    secrets,
    groups: basicResetReducer(groups, authSessionEnd.toString()),
    whitelist: basicResetReducer(whitelist, authSessionEnd.toString()),
    securityAudit: basicResetReducer(securityAudit, authSessionEnd.toString()),
    settings: basicResetReducer(settings, authSessionEnd.toString()),
});

export default entitiesReducer;
